import type { ItinerarySuggestion } from "../types";

export type ItinerarySuggestionThread = ItinerarySuggestion & {
  replies: ItinerarySuggestion[];
};

/** 将扁平建议列表整理为顶层建议及其回复线程。 */
export function groupItinerarySuggestions(
  suggestions: ItinerarySuggestion[],
): ItinerarySuggestionThread[] {
  const sorted = [...suggestions].sort((left, right) => (
    left.createdAt.localeCompare(right.createdAt) || left.id.localeCompare(right.id)
  ));
  const repliesByParent = new Map<string, ItinerarySuggestion[]>();
  const roots: ItinerarySuggestion[] = [];

  for (const suggestion of sorted) {
    if (suggestion.parentId) {
      const replies = repliesByParent.get(suggestion.parentId) ?? [];
      replies.push(suggestion);
      repliesByParent.set(suggestion.parentId, replies);
      continue;
    }
    roots.push(suggestion);
  }

  return roots.map((root) => ({
    ...root,
    replies: repliesByParent.get(root.id) ?? [],
  }));
}
